import { GlassesOne } from '@icon-park/react'

import React, { memo, useEffect, useMemo } from 'react'

import { useRouting } from '@/hooks'

import { Button } from '@/components'
import { ManualCard, Modal } from '@/components/derived'

import { Routes } from '@/configs'
import { useCompanyContext } from '../CompanyDetails.context'
import { CompanyCompetitorsTable } from './CompanyCompetitors.table'
import { getDescription } from '../utils'
import { HealthStatus } from '@/pages/Home/Home.component'

const Component: React.FC = (): JSX.Element | null => {
  const { companyID, changeQueryParam, navigate } = useRouting()
  const { company, companyCompetitors, fetchCompanyCompetitors } = useCompanyContext()

  function handleNavigation(): void {
    navigate(`${Routes.Companies.path}?mae=${companyID}`)
  }

  useEffect(() => {
    fetchCompanyCompetitors({
      loadHealthCheck: true,
    })
  }, [fetchCompanyCompetitors])

  const status = useMemo((): HealthStatus => {
    const competitors = companyCompetitors?.elements ?? []

    if (competitors.length === 0) {
      return 'error'
    }

    const keysToIgnore: string[] = ['isKeyMessagesChecked', 'isClipperChecked']

    const allCompetitorsHealth = competitors.map((competitor) => {
      const health = competitor.healthCheck

      if (!health || Object.keys(health).length === 0) {
        return true
      }

      return Object.entries(health)
        .filter(([key]) => !keysToIgnore.includes(key))
        .every(([_, value]) => value === true)
    })

    const isAllFalse = allCompetitorsHealth.every((value) => value === false)
    const isAllTrue = allCompetitorsHealth.every((value) => value === true)

    const currentStatus: HealthStatus =
      isAllFalse ? 'error'
      : isAllTrue ? 'success'
      : 'warning'

    return currentStatus
  }, [companyCompetitors])

  if (!companyID || !company) return null

  return (
    <>
      <ManualCard
        icon={GlassesOne}
        healthCheck={status}
        title="Concorrentes da Empresa"
        tooltip="Cadastre concorrentes para análise comparativa. Esta função redireciona para um formulário de cadastro completo da empresa concorrente."
        description={getDescription(company.counts?.competitors)}
        linkName="Editar"
        linkAction={() =>
          changeQueryParam({
            param: 'modal',
            value: 'concorrentes',
            replaceAll: true,
          })
        }
      />
      <Modal controlKey="concorrentes" backToName={company.name} title="Concorrentes da Empresa" icon={GlassesOne}>
        <Button.Root $variant="primary" onClick={handleNavigation}>
          <Button.Text value="Cadastrar Concorrente" />
        </Button.Root>
        <CompanyCompetitorsTable />
      </Modal>
    </>
  )
}

export const CompanyCompetitors = memo(Component)
